import { ControlCommunicationService } from '@app/form-builder/services/control-communication.service'
import { Component, OnInit, Input } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, tap, switchMap } from 'rxjs/operators';
import { SubstancesService, AuthenticationService, AccompanyingService } from '@app/core/services'

import { FormBuilderComponent } from '@app/form-builder/form-builder.component'
import { UnknownParams, ControlElement } from '@app/form-builder/interfaces/form.interface'
import { FormGroup } from '@angular/forms';
import { User } from '@app/core/models';

@Component({
    selector: 'search-element',
    templateUrl: './search.component.html'
  })
  export class SearchComponent implements OnInit {
    user: User
    type = ''

    model: any;
    searching = false;
    searchFailed = false;

    attributes: UnknownParams = {}
    validations: UnknownParams = {}

    @Input() data: ControlElement

    @Input() form: FormGroup
  
    constructor(
        private authenticationService: AuthenticationService,
        private substancesService: SubstancesService,
        private parentControl: FormBuilderComponent,
        private communication: ControlCommunicationService,
        private accompanyingService: AccompanyingService
    ) {
        this.user = this.authenticationService.userValue;
        switch (this.user.type) {
            case "ROOT":
                this.type = 'Administrador'
                break;
            case "OPERADOR":
                this.type = 'Operador'
                break;
            case "CAPTURISTA":
                this.type = 'Capturista'
                break;
            case "RESPONSABLE":
                this.type = 'Responsable'
                break;
            case "ADMINISTRADOR":
                this.type = 'Administrador'
                break;
            case "DIRECTOR_CERTIFICACION":
                this.type = 'Supervisor'
                break;
            case "REVISOR":
                this.type = 'Revisor'
                break;
            case "INSPECTOR":
                this.type = 'Inspector'
                break;
            case "DICTAMINADOR":
                this.type = 'Dictaminador'
                break;
            case "OBSERVADOR":
                this.type = 'Observador'
                break;
            default:
                break;
        }
    }

    ngOnInit() {
        //console.log(this.data)
        //console.log(this.form)

        if (!this.form) {this.form = this.parentControl.formGroup}
        for (var i in this.data.attributes) {
            const attribute = this.data.attributes[i]
            this.attributes[attribute.name] = attribute.value
        }
        for (var i in this.data.validations) {
            const validation = this.data.validations[i]
            this.validations[validation.name] = validation.value
        }
    }
  
    search = (text$: Observable<string>) =>
        text$.pipe(
            debounceTime(300),
            distinctUntilChanged(),
            tap(() => this.searching = true),
            switchMap(term =>
                this.substancesService.searchSubstances(term).pipe(
                    tap(() => this.searchFailed = false),
                    catchError(() => {
                        this.searchFailed = true;
                        return of([]);
                    })
                )
            ),
            tap(() => this.searching = false)
        )

    searchBuyer = (text$: Observable<string>) =>
        text$.pipe(
            debounceTime(300),
            distinctUntilChanged(),
            tap(() => this.searching = true),
            switchMap(term => 
                this.accompanyingService.getBuyers(Number(localStorage.getItem('customerId') || 0), term).pipe(
                    tap(() => this.searchFailed = false),
                    catchError(() => {
                        this.searchFailed = true;
                        return of([]);
                    })
                )
            ),
            tap(() => this.searching = false)
        )

    formatter = ( substance: string ) => 
        // console.log(substance['nombre_comercial']) 
        substance['nombre_comercial']

    formatterBuyer = (buyer: string) => {
        // console.log(buyer['name']) 
        buyer['name']
    }

    loadSubstance(event) {
        //console.log(event)
        //console.log(this.form)

        this.form.patchValue({
            nombre_comercial: event.item["nombre_comercial"],
            //cultivo_area_aplicacion: event.item["cultivo_area_aplicacion"],
            ficha_tecnica_anexos_urls: event.item["ficha_tecnica_anexos_urls"],
            ingredientes_activos: event.item["ingredientes_activos"],
            ingredientes_inertes: event.item["ingredientes_inertes"],
            isValidated: event.item["isValidated"],
            listado_omri_canada: event.item["listado_omri_canada"],
            listado_omri_nop: event.item["listado_omri_nop"],
            listado_otro: event.item["listado_otro"],
            listado_otro_texto: event.item["listado_otro_texto"],
            nombre_proveedor: event.item["nombre_proveedor"],
            //uso_abono_fungicida_etc: event.item["uso_abono_fungicida_etc"]
        })


        setTimeout(() => {
            this.communication.emitEvent({
                identifier: 'set-values',
                form: this.form
            })
        }, 100);
    }

    loadBuyers(event) {
        // console.log(event)

        this.form.patchValue({
            nombre_comprador: event.item['name'],
            direccion_comprador: event.item['address']
        })

        setTimeout(() => {
            this.communication.emitEvent({
                identifier: 'set-values',
                form: this.form
            })
        }, 100)
    }
  }